<template>
  <div>
    <div class="list-search">
      <p class="control has-icons-left">
        <span class="icon">
          <inline-svg :src="require('../assets/icons/search.svg')"></inline-svg>
        </span>
        <input v-model="filterText" class="input" type="text" :placeholder="$t('admin.tabs.invoicingCompanies.searchButton')" />
      </p>
    </div>

    <div>
      <div v-if="!loading">
        <div class="form column is-5">
          <h3>{{ $t('admin.tabs.invoicingCompanies.title') }}</h3>
          <div class="form-wrapper">
            <div v-for="(invoicingCompany, index) in filteredInvoicingCompanies" :key="invoicingCompany.id" class="form-field">
              <div class="field is-horizontal">
                <div class="field-label is-counter">
                  <span class="label">{{ parseInt(index) + 1 }}</span>
                </div>
                <div class="field-body">
                  <div class="field">
                    <p class="control">
                      <input v-model="invoicingCompany.name" :readonly="!invoicingCompany.isEditing" class="input" />
                    </p>
                  </div>
                  <div class="field is-narrow">
                    <p class="control">
                      <button v-if="!invoicingCompany.isEditing" class="button is-input" @click="editItem(invoicingCompany.id)">
                        <span class="icon">
                          <inline-svg :src="require('../assets/icons/edit.svg')"></inline-svg>
                        </span>
                      </button>
                      <button v-else class="button is-input" @click="processItem(invoicingCompany)">
                        <span class="icon is-green">
                          <inline-svg :src="require('../assets/icons/save.svg')"></inline-svg>
                        </span>
                      </button>
                      <a class="field-delete" @click.prevent="deleteItem(invoicingCompany)">
                        <span class="icon">
                          <inline-svg :src="require('../assets/icons/trash-can.svg')"></inline-svg>
                        </span>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-field">
              <div class="field is-horizontal level-right">
                <div class="field is-grouped">
                  <p class="control">
                    <button class="button is-input" @click="addItem">
                      <span class="icon">
                        <inline-svg :src="require('../assets/icons/plus-circle.svg')"></inline-svg>
                      </span>
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as invoicingCompanyService from '@/api/invoicingCompanyService';
  import { searchTerm } from '@/filters';

  export default {
    name: 'AdminInvoicingCompanies',
    data() {
      return {
        loading: false,
        filterText: null,
        invoicingCompanies: [],
      };
    },
    computed: {
      filteredInvoicingCompanies() {
        if (this.filterText && this.filterText !== '') {
          return this.invoicingCompanies.filter(item => searchTerm(item.name, this.filterText));
        } else {
          return this.invoicingCompanies;
        }
      },
    },
    mounted() {
      this.fetchData();
    },
    methods: {
      async fetchData() {
        await Promise.all([this.loadInvoicingCompanies()]);
      },
      editItem(id) {
        this.$set(
          this.invoicingCompanies.find(item => item.id === id),
          'isEditing',
          true
        );
      },
      addItem() {
        this.invoicingCompanies.push({ name: '', isEditing: true });
      },
      processItem(data) {
        data.id ? this.updateItem(data) : this.setNewItem(data);
      },
      async updateItem({ id, name }) {
        try {
          this.loading = true;
          const res = await invoicingCompanyService.updateInvoicingCompany(id, { name, active: true });
          if (res.status === 200) await this.loadInvoicingCompanies();
        } finally {
          this.loading = false;
        }
      },
      async deleteItem({ id, name }) {
        if (!id) {
          this.invoicingCompanies.splice(-1, 1);
        } else {
          try {
            this.loading = true;
            const res = await invoicingCompanyService.updateInvoicingCompany(id, { name, active: false });
            if (res.status === 200) await this.loadInvoicingCompanies();
          } finally {
            this.loading = false;
          }
        }
      },
      async setNewItem({ name }) {
        if (name) {
          try {
            this.loading = true;
            const res = await invoicingCompanyService.createNewInvoicingCompany({ name });
            if (res.status === 201) await this.loadInvoicingCompanies();
          } finally {
            this.loading = false;
          }
        }
      },
      async loadInvoicingCompanies() {
        try {
          this.loading = true;
          const invoicingCompanies = await invoicingCompanyService.getInvoicingCompanies('active');
          this.invoicingCompanies = invoicingCompanies.sort((a, b) => a.name.localeCompare(b.name));
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
